<styles-smart-table
  #smartTable
  [datasource]="tasks.items"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [showColumnHeaders]="showColumnHeaders"
  matSort
  (matSortChange)="updateSort($event)"
  [matSortActive]="buildSort()?.active"
  [matSortDirection]="buildSort()?.direction"
>
  <ng-container matColumnDef="status-icon">
    <th
      mat-header-cell
      *matHeaderCellDef
      columnName="status-icon"
      mat-sort-header
      [sharedListingColumnWidth]="columnBuilder"
    ></th>
    <td mat-cell *matCellDef="let element" columnName="status-icon" [sharedListingColumnWidth]="columnBuilder">
      <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
        {{ $any(element).status | statusCircleIcon}}
      </mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
      mat-sort-header
    >
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      <styles-icon-value-caption
        icon="corporate_fare"
        caption="Organization"
        *ngIf="element.feedDetails"
        [matTooltip]="$any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName"
      >
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="default">Task</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div>
          <div class="title" [matTooltip]="element | projectNamePipe">
            <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
              {{ element | workSpaceType | spaceTypeIcon }}
            </mat-icon>
            <span class="ellipsis-text"> {{ element | projectNamePipe }} </span>
          </div>
          <div class="sub-title" [ngClass]="{ 'dark-mode': selectDarkMode(element) }">
            <mat-icon class="color-icon" [class]="element | workSpaceType | spaceTypeColor">
              {{ $any(element).status | statusCircleIcon}}
            </mat-icon>
            <ng-container
              *ngIf="(element | hasMaster) && ((element | spaceName) !== element.name && (element | spaceName) !== (element | phaseNamePipe) && (element | spaceName) !== (element | projectNamePipe))"
            >
              <span class="ellipsis-text">{{ element | spaceName }} </span>
              <mat-icon class="arrow-icon"> arrow_forward </mat-icon>
            </ng-container>
            <ng-container *ngIf="nonMatchingTaskName(element)">
              <span class="ellipsis-text">{{ element | phaseNamePipe }} </span>
              <mat-icon class="arrow-icon"> arrow_forward </mat-icon>
            </ng-container>
            <span class="ellipsis-text"> {{ element.name }} </span>
            <mat-chip-list *ngIf="element | versionFormatedPipe" [selectable]="false">
              <mat-chip>{{ element | versionFormatedPipe }}</mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      Content Type
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      <div class="task-box">
        <styles-icon-value-caption
          caption="Content Type"
          icon="eco"
          [matTooltip]="element | contentType"
          *ngIf="element | contentType; else noContentType"
        >
          {{ element | contentType }}<ng-container
            *ngIf="(element |
          findSpace).productInstance?.variant"
            >&nbsp;•&nbsp;{{ (element | findSpace).productInstance.variant }}</ng-container
          >
        </styles-icon-value-caption>

        <ng-template #noContentType>
          <styles-icon-value-caption
            caption="Product Type"
            icon="category"
            *ngIf="(element | findSpace).productInstance"
            [matTooltip]="(element | findSpace).productInstance.name + ' - ' + (element | findSpace).productInstance.variant"
          >
            {{ (element | findSpace).productInstance.name }}<ng-container
              *ngIf="(element |
            findSpace).productInstance.variant"
              >&nbsp;•&nbsp;{{ (element | findSpace).productInstance.variant }}</ng-container
            >
          </styles-icon-value-caption>
        </ng-template>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="units">Units</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="units">
      <div class="task-box">
        <styles-icon-value-caption
          caption="Core"
          icon="star"
          *ngIf="element.units?.currency && element.units.currency.id === 'CoreSmb' && element.units.totalUnits > 0"
          [matTooltip]="generateUnitsTip(element)"
        >
          {{element.units?.totalUnits | number : '1.0-2'}}
        </styles-icon-value-caption>

        <styles-icon-value
          icon="star"
          *ngIf="element.units?.currency && element.units.currency.id === 'SparkResponsive' && element.units.totalUnits > 0"
          [matTooltip]="generateUnitsTip(element)"
        >
          {{element.units?.totalUnits | number : '1.0-2'}}
        </styles-icon-value>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner" mat-sort-header>
      Owner
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name" actionLauncher="Assign" [task]="element">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="date" mat-sort-header>
      Due
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="date">
      <div class="task-box">
        <!-- Note - not using icon-value-caption as we need to link to separate actions from the header vs the footer. -->
        <div
          class="date-widget"
          [matTooltip]="'Planned: ' + getPlannedCaption($any(element)?.workStart, $any(element)?.workEnd) + '&#13;' + 'Due: ' +( $any(element)?.phaseEnd | date : getDateFormat($any(element)?.phaseEnd))"
          matTooltipClass="line-broken-tooltip"
          [ngClass]="{
          'overdue-due':
            ($any(element)?.phaseEnd | overduePipe) &&
            $any(element).status.id !== 'Completed' &&
            $any(element).status.id !== 'Cancelled',
            'overdue-planned' :
            ($any(element)?.workEnd | overduePipe) &&
            $any(element).status.id !== 'Completed' &&
            $any(element).status.id !== 'Cancelled'
        }"
        >
          <div class="planned-date" actionLauncher="ChangeWorkDates" [task]="element">
            {{ getPlannedCaption($any(element)?.workStart, $any(element)?.workEnd) }}
          </div>
          <div class="internal-due-date">
            <mat-icon>date_range</mat-icon>
            <span class="date-value" actionLauncher="ChangeDates" [task]="element">
              {{ $any(element)?.phaseEnd | date : getDateFormat($any(element)?.phaseEnd) }}
            </span>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="status"
      mat-sort-header
    >
      Status
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip [workStatus]="$any(element)?.status"></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="actions"></th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="actions">
      <div class="task-box">
        <framework-action-button [task]="element" [iconSize]="18" *ngIf="element.defaultAction">
        </framework-action-button>
        <shared-listing-action-dropdown
          menu
          *ngIf="($any(element)?.actions)!.length > 0"
          level="task"
          [location]="element | moduleTypePipe"
          [masterProject]="element | findMaster"
          [project]="element | findSpace"
          [phase]="element | phasePipe"
          [task]="element"
          [actions]="$any(element)?.actions"
        >
        </shared-listing-action-dropdown>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-owner">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-person-image [person]="group.group" size="40px"></framework-person-image>
        {{ group.group.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-date">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper"><mat-icon>calendar_today</mat-icon>{{group.group | date : 'MMMM y'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-organization">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <mat-icon>corporate_fare</mat-icon>
        {{ group.group.organizationName || group.group.feedName}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-status">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-work-status-chip [workStatus]="group.group"></framework-work-status-chip>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
